import { assetUrl } from "@/lib/api";

function filenameFor(item, index = 0) {
  const ext = item.url.split(".").pop().split("?")[0];
  const base = (item.caption || item.uploaded_by_name || `file-${index + 1}`).trim().replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  return `${base || `file-${index + 1}`}.${ext}`;
}

function clickLink(href) {
  const a = document.createElement("a");
  a.href = href;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// Forces a save via a plain link, not fetch()/blob() -- the server answers with
// Content-Disposition: attachment, which works across origins natively and
// isn't subject to whatever can make a JS-mediated fetch() download fail
// (some privacy/ad-blocking extensions block background fetch/XHR to a
// different subdomain while still allowing a plain link navigation, which is
// exactly the split seen in practice: single-file worked, the old fetch-based
// zip didn't). Used by both the dashboard and the public album.
export function downloadSingle(item, index = 0) {
  const base = assetUrl(item.url);
  const sep = base.includes("?") ? "&" : "?";
  clickLink(`${base}${sep}download=${encodeURIComponent(filenameFor(item, index))}`);
}

// The zip itself is now built server-side (reading straight from R2, see
// worker/src/lib/zip.ts) -- this just triggers a plain link to it, same as
// downloadSingle, so the browser never needs fetch()/blob() to assemble it.
// `ownerEndpoint`/`publicEndpoint` select which API route to hit.
export function downloadZip({ ids, ownerWeddingId, publicSlug }) {
  const idsParam = ids?.length ? `ids=${ids.map(encodeURIComponent).join(",")}` : "";
  if (ownerWeddingId) {
    const params = ["wedding_id=" + encodeURIComponent(ownerWeddingId), idsParam].filter(Boolean).join("&");
    clickLink(`${assetUrl(`/api/owner/photos/zip`)}?${params}`);
  } else if (publicSlug) {
    const params = idsParam;
    clickLink(`${assetUrl(`/api/public/${publicSlug}/photos/zip`)}${params ? `?${params}` : ""}`);
  }
}
